<template>
    <div @click="(e) => e.stopPropagation()">
        <analogues_selection style="cursor: default;" ref="analogues_selection" v-on:need_refresh="ev => analogues_selection_refresh(ev)" />

        <b-dropdown class="transparent without-after">
    
            <template #button-content>
                <base-icon name="more_vert" />
            </template>
    
            <b-dropdown-item v-on:click="analogues_selection">
                Подобрать объекты-аналоги
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>

import analogues_selection from "../cadastral/analogues/selection.vue"

export default
{
    components :
    {
        analogues_selection,
    },

    methods :
    {
		analogues_selection()
        {
            this.$refs.analogues_selection.execute()
        },

        analogues_selection_refresh(ev)
        {
            if(ev.analogues_all)
				this.$emit("change_type")
            else if(ev.query.length)
				this.$emit("change_type", { "and" : ev.query })
        },
    }
}
</script>
